import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import clsx from 'clsx'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { rem } from 'polished'
import { accountAccessShowLogin } from 'actions/UiActions'
import SocialButtons from 'components/Account/AccountAccess/AccountAccessSocialButtons'
import { mediaQueryUp } from 'components/utils/breakpoint'
import SocialStars from 'components/Common/SocialStars/SocialStars'
import TextButton from 'LuxKit/Button/TextButton'
import TextLink from 'LuxKit/TextLink'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const ButtonsBlock = styled.div`
  padding: 0 ${rem(20)};
`

const Wrapper = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  padding: ${rem(30)} ${rem(25)} ${rem(25)};

  ${mediaQueryUp.desktop} {
    margin-left: auto;
    max-width: ${rem(360)};

    // bandaid fix for centering hub page modal until design & marketing update
    &.hub {
      margin: auto;
    }
  }
`

interface Props {
  title: string
  prefix?: string
  className?: string
  accountAccessShowLogin: () => void
  isStoreMode: boolean
  version?: string
}

function SignUpBox(props: Props) {
  const intl = useIntl()

  if (props.isStoreMode) {
    return null
  }

  return <Wrapper className={clsx(props.className, props.version)}>
    <Heading variant="heading5" align="center">
      {intl.formatMessage({ id: 'k3TuelK7ZEntO-quwmuS', defaultMessage: 'Get exclusive offers to amazing destinations', description: 'Heading for the sign-up box on landing page encouraging users to join' })}
    </Heading>

    <VerticalSpacer gap={24}>
      <SocialStars prefix={props.prefix} />
      <ButtonsBlock>
        <VerticalSpacer gap={12}>
          <SocialButtons mode="join" hideText inline />
          <TextButton
            kind="primary"
            onClick={() => props.accountAccessShowLogin()}
            fit="flex"
          >
            {intl.formatMessage({ id: 'JtbdkmQRdqdZs3X9SZ1Q', defaultMessage: 'Sign up with email', description: 'Button text to sign up with email on landing page sign-up box' })}
          </TextButton>
          <BodyText variant="large" align="center">
            <FormattedMessage
              id="IqdPK7K5yUT14_ie20es"
              defaultMessage="Already have an account? <link>Log in</link>"
              description="Text with login link for existing users on landing page sign-up box"
              values={{
                link: (chunks: React.ReactNode) => <TextLink onClick={() => props.accountAccessShowLogin()}>{chunks}</TextLink>,
              }}
            />
          </BodyText>
        </VerticalSpacer>
      </ButtonsBlock>
    </VerticalSpacer>
  </Wrapper>
}

function mapStateToProps(state: App.State) {
  return {
    isStoreMode: state.system.storeMode,
  }
}

const mapDispatchToProps = {
  accountAccessShowLogin,
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpBox)
